import { SpinResponse } from '@cgs/data-access';
import { CgsEvent, Rule } from '@cgs/wge';
import { BaseGameState } from '../../states/base_game_state';
import { ResponseHolder } from '../../response_holder';

export class BaseGameRule<TResponse extends SpinResponse> extends Rule {
  public targetState: BaseGameState<TResponse>;

  private _triggered: boolean = false;
  private readonly _sourceState: BaseGameState<TResponse>;
  private readonly _responseHolder: ResponseHolder<TResponse>;

  constructor(sourceState: BaseGameState<TResponse>, responseHolder: ResponseHolder<TResponse>) {
    super();
    this._sourceState = sourceState;
    this._responseHolder = responseHolder;
  }

  public get isTriggered(): boolean {
    return this._triggered;
  }

  public dispatchEvent(_event: CgsEvent): void {
    this._triggered = this.ruleCondition(this._responseHolder) && this._sourceState.isFinished;
  }

  public setActive(_active: boolean): void {
    this._triggered = false;
  }

  public update(_dt: number): void {
    this._triggered = this.ruleCondition(this._responseHolder) && this._sourceState.isFinished;
  }

  protected ruleCondition(_responseHolder: ResponseHolder<TResponse>): boolean {
    return true;
  }

  protected set triggered(value: boolean) {
    this._triggered = value;
  }

  protected get sourceState(): BaseGameState<TResponse> {
    return this._sourceState;
  }

  protected get responseHolder(): ResponseHolder<TResponse> {
    return this._responseHolder;
  }
}
